/* AMBRE advertorial behaviours: accordion, countdown, carousel, in-page anchors. */
(function () {
  if (window.__amAdv) return; window.__amAdv = true;
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function deadline(cfg) {
    var p = (cfg || '').split(/\s+/), now = Date.now();
    if (p[0] === 'evergreen') {
      var mins = parseFloat(p[1]) || 180, key = 'amAdvCd' + mins, t = 0;
      try { t = parseInt(sessionStorage.getItem(key), 10) || 0; } catch (e) {}
      if (!t || t < now) { t = now + mins * 60000; try { sessionStorage.setItem(key, String(t)); } catch (e) {} }
      return t;
    }
    if (p[0] === 'date') { var d = Date.parse(p[1]); return isNaN(d) ? now : d; }
    var hm = (p[1] || '23:59').split(':'), off = parseFloat(p[2]) || 0;
    var d2 = new Date(now + off * 3600000);
    var end = Date.UTC(d2.getUTCFullYear(), d2.getUTCMonth(), d2.getUTCDate(), parseInt(hm[0], 10) || 0, parseInt(hm[1], 10) || 0, 0) - off * 3600000;
    if (end <= now) end += 86400000;
    return end;
  }
  function countdown(root) {
    var end = deadline(root.getAttribute('data-am-cfg'));
    var q = function (u) { return root.querySelectorAll('[data-am="cd-' + u + '"]'); };
    var set = function (u, v) { var els = q(u); for (var i = 0; i < els.length; i++) { var t = els[i]; while (t.children.length === 1) t = t.firstElementChild; if (t.textContent !== pad(v)) t.textContent = pad(v); } };
    var hasDay = q('day').length > 0;
    function tick() {
      var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (s === 0) { end = deadline(root.getAttribute('data-am-cfg')); }
      var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60);
      if (hasDay) set('day', d); else h += d * 24;
      set('hour', h); set('minute', m); set('second', s % 60);
    }
    tick(); setInterval(tick, 1000);
  }
  function carousel(root) {
    var track = root.querySelector('[data-am="track"]') || root, slides = root.querySelectorAll('[data-am="slide"]');
    if (!slides.length) return;
    var step = function (dir) { track.scrollBy({ left: dir * slides[0].getBoundingClientRect().width, behavior: 'smooth' }); };
    var n = root.querySelectorAll('[data-am="car-next"]'), p = root.querySelectorAll('[data-am="car-prev"]'), i;
    for (i = 0; i < n.length; i++) n[i].addEventListener('click', function (e) { e.preventDefault(); step(1); });
    for (i = 0; i < p.length; i++) p[i].addEventListener('click', function (e) { e.preventDefault(); step(-1); });
  }
  function init() {
    var i, els = document.querySelectorAll('.am-adv [data-am="cd"]');
    for (i = 0; i < els.length; i++) if (!els[i].__am) { els[i].__am = 1; countdown(els[i]); }
    els = document.querySelectorAll('.am-adv [data-am="carousel"]');
    for (i = 0; i < els.length; i++) if (!els[i].__am) { els[i].__am = 1; carousel(els[i]); }
  }
  document.addEventListener('click', function (e) {
    var h = e.target.closest && e.target.closest('.am-adv [data-am="acc-head"]');
    if (h) {
      var b = h.nextElementSibling;
      while (b && b.getAttribute('data-am') !== 'acc-body') b = b.nextElementSibling;
      if (b) { var open = getComputedStyle(b).maxHeight !== '0px'; b.classList.toggle('is-open', !open); b.classList.toggle('is-closed', open); h.classList.toggle('is-open', !open); }
      return;
    }
    var a = e.target.closest && e.target.closest('.am-adv a[href^="#"]');
    if (a) {
      var id = a.getAttribute('href').slice(1); e.preventDefault();
      if (!id || id === 'scroll-to-top') { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
      var t = document.getElementById(id); if (t) t.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
